<div class="app-hexagon-list">
  <div class="hexagon-container">
    <div *ngFor="let item of list;" class="cursor text-white"
      [ngStyle]="{'background-color': item?.isActive ? item?.utilisation?.colorCode : item?.utilisation?.backgroundColorCode}"
      title="{{ item.label }}" (click)="onBlockClick(item)">
      <div class="d-flex align-items-center flex-column justify-content-center text-black">
        <img
          src="{{ item?.isActive ? '../../../assets/images/icon-check-circle-active.svg' : '../../../assets/images/icon-check-circle-inactive.svg' }}"
          alt="check_circle">
        <h3 class="hexagon-text" [ngClass]="{'hexagon-active': item?.isActive}">
          {{ item.label | truncate:13 }}</h3>
        <span class="hexagon-value">
          <ng-container *ngIf="item?.value; else valueDefault;">
            <span *ngIf="item?.value!=='unknown'">{{ item?.value | number:'1.2-2' }}{{ item?.unit }}</span>
            <span *ngIf="item?.value==='unknown'">{{ item?.value}}</span>
          </ng-container>
          <ng-template #valueDefault>-</ng-template>
        </span>
      </div>
    </div>
  </div>
</div>